import { TurnDetailResource } from '@appTypes/TurnDetailResource';
import { TurnPortfolioResource } from '@appTypes/TurnPortfolioResource';
import { TurnActionType, TurnDetailActions } from './TurnDetailAction';

export type TurnDetailState = {
  turnDetails: TurnDetailResource | null;
  selectedVehicleDetail: TurnPortfolioResource | null;
  loading: boolean;
  error: boolean;
};

export const initialTurnDetailState: TurnDetailState = {
  turnDetails: null,
  selectedVehicleDetail: null,
  loading: false,
  error: false,
};

export const turnDetailReducer = (
  state: TurnDetailState = initialTurnDetailState,
  action: TurnDetailActions,
): TurnDetailState => {
  switch (action.type) {
    case TurnActionType.TURN_DETAIL_LOADING:
      return {
        ...initialTurnDetailState,
        turnDetails: null,
        loading: true,
        error: false,
      };
    case TurnActionType.TURN_DETAIL_LOADED:
      return {
        ...initialTurnDetailState,
        turnDetails: action.payload,
        loading: false,
        error: false,
      };
    case TurnActionType.TURN_DETAIL_ERROR:
      return {
        ...initialTurnDetailState,
        turnDetails: null,
        loading: false,
        error: true,
      };
    case TurnActionType.TURN_DETAIL_REMOVE:
      return {
        ...initialTurnDetailState,
      };
    case TurnActionType.TURN_DETAIL_REMOVE_RECORD:
      return {
        ...initialTurnDetailState,
        turnDetails: {
          ...state.turnDetails,
          mappingCustomers: state.turnDetails.mappingCustomers.filter(
            (customer) => customer.closedDealId !== action.payload,
          ),
        },
      };
    case TurnActionType.SELECT_VEHICLE_DETAIL:
      return {
        ...initialTurnDetailState,
        selectedVehicleDetail: action.payload,
        loading: false,
        error: false,
      };
    case TurnActionType.POTENTIAL_BUYER_INCREMENT_NOTES_COUNT:
      const potentialBuyer = state.turnDetails.mappingCustomers.find(
        (e) => e.closedDealId === action.payload.closedDealId,
      );
      if (potentialBuyer !== null && potentialBuyer !== undefined) {
        potentialBuyer.noteCount += action.payload.addedNotesCount;
        state.turnDetails.mappingCustomers = Array.from(
          new Set([...state.turnDetails.mappingCustomers, potentialBuyer]),
        );
      }

      return {
        ...initialTurnDetailState,
        turnDetails: state.turnDetails,
        loading: false,
        error: false,
      };
    case TurnActionType.POTENTIAL_BUYER_UPDATE_LAST_UPDATE:
      const tempPotentialBuyer = state.turnDetails.mappingCustomers.find(
        (e) => e.closedDealId === action.payload.closedDealId,
      );
      if (tempPotentialBuyer !== null && tempPotentialBuyer !== undefined) {
        tempPotentialBuyer.closedDeal.sinceUpdatedDate = action.payload.daysSinceLastUpdate;
        state.turnDetails.mappingCustomers = Array.from(
          new Set([...state.turnDetails.mappingCustomers, tempPotentialBuyer]),
        );
      }

      return {
        ...initialTurnDetailState,
        turnDetails: state.turnDetails,
        loading: false,
        error: false,
      };
    default:
      return state;
  }
};
